import React, {  useEffect } from 'react';
import { connect,useDispatch } from 'react-redux';
import { compose } from 'redux';
// import { useParams } from 'react-router-dom';
import {getDataOnRequest} from '../redux/actions/CommonActions'
import { toast } from 'react-toastify';
const DocumentRequiredsContainer = (OriginalComponent) => {
    //This Is The Important Code
  const NewComponent = (props) => {
    const dispatch = useDispatch();
    useEffect(()=>{
      toast.dismiss();
      if(props.userAuth.users_access_token && props.documentCompliance.length <= 0){       
          dispatch(getDataOnRequest(props.userAuth.users_access_token,'SetDocumentCompliance','SET_DOCUMENT_COMPLIANCE'))
      }
    },[props.userAuth.users_access_token,dispatch,  props.documentCompliance.length,])

    return (
      <OriginalComponent {...props}  />
    )
  }
  return NewComponent
}

const mapStateToProps = (state) => {
  return {
    documentCompliance:state.documentCompliance.documentCompliance,
    userAuth:state.auth.authUserData,
    userInfo:state.userProfile.userData
  };
};

const composedDocumentRequired = compose(connect(mapStateToProps), DocumentRequiredsContainer)
export default composedDocumentRequired;


